import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../store/user';

/** Login fields are never saved to browser storage (#152), so after a page reload
 * they are missing from the user in memory. Screens that read or save them call
 * this to reload the user from the server once per visit. */
const useRestorePrivateUserFields = () => {
	const dispatch = useDispatch();
	const username = useSelector((st) => st.user.currentUser?.username);
	const token = useSelector((st) => st.user.token);
	const isMissing = useSelector((st) => st.user.currentUser?.crmUsername === undefined);
	const requestedFor = useRef(null);

	useEffect(() => {
		// One request per user per visit: getUser hands back a fresh token, which
		// must not trigger another request.
		if (!username || !token || !isMissing || requestedFor.current === username) return;
		requestedFor.current = username;
		dispatch(getUser({ username, token }));
	}, [username, token, isMissing, dispatch]);
};

export default useRestorePrivateUserFields;
